module.exports = ["StreamingMetaMultiSigWallet"];